import { TSecurityType } from '@brickwise/asset-validation/dist/schema/enums';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultSelectField } from 'src/components/mui-overrides/SelectTextField';

interface Props {
  disabled?: boolean;
}

export const SecurityTypeSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  return (
    <DefaultSelectField
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.securitytype.fields.securityType')}
      fieldName="investmentDetails.securityType"
      formik={formik}
      options={[
        {
          value: TSecurityType.participationRightEquity,
          label: t('general.securitytype.participationRightEquity'),
        },
        // Temporarily removed
        // {
        //   value: TSecurityType.participationRightEquityBuilderOwner,
        //   label: t('general.securitytype.participationRightEquityBuilderOwner'),
        // },
        {
          value: TSecurityType.participationRightDebtCapital,
          label: t('general.securitytype.participationRightDebtCapital'),
        },
        // Temporarily removed
        // {
        //   value: TSecurityType.participationRightDebtCapitalPartialSale,
        //   label: t('general.securitytype.participationRightDebtCapitalPartialSale'),
        // },
        {
          value: TSecurityType.participationAtypicalSilent,
          label: t('general.securitytype.participationAtypicalSilent'),
        },
        {
          value: TSecurityType.participationKG,
          label: t('general.securitytype.participationKG'),
        },
        {
          value: TSecurityType.purchaseWithManagementOutsourcing,
          label: t('general.securitytype.purchaseWithManagementOutsourcing'),
        },
        {
          value: TSecurityType.participationRightSubordinatedLoan,
          label: t('general.securitytype.participationRightSubortinatedLoan'),
        },
      ]}
    />
  );
};
